// Print a sales receipt to a thermal-style 80mm page.
export interface ReceiptItem {
  name: string;
  qty: number;
  price: number;
}

export interface ReceiptInput {
  invoiceNumber: string;
  date?: Date | string;
  customerName?: string | null;
  customerEmail?: string | null;
  customerPhone?: string | null;
  items: ReceiptItem[];
  subtotal: number;
  tax: number;
  total: number;
  store?: {
    name?: string;
    address?: string;
    phone?: string;
  };
}

const escapeHtml = (s: string) =>
  s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

export const printReceipt = (r: ReceiptInput) => {
  const w = window.open("", "_blank");
  if (!w) return;

  const store = {
    name: r.store?.name || "LINK TO THE PAST",
    address: r.store?.address || "124 Williams St, Lockland",
    phone: r.store?.phone || "",
  };
  const date = r.date ? new Date(r.date) : new Date();
  const dateStr = date.toLocaleString();

  const itemRows = r.items
    .map((it) => {
      const line = it.price * it.qty;
      return `<tr><td class="qty">${it.qty}</td><td class="name">${escapeHtml(it.name)}</td><td class="amt">$${line.toFixed(2)}</td></tr>`;
    })
    .join("");

  const cust = [r.customerName, r.customerEmail, r.customerPhone].filter(Boolean).join(" · ");

  w.document.write(`<!doctype html>
<html><head><title>Receipt ${escapeHtml(r.invoiceNumber)}</title>
<style>
  /* Dymo 30330 (2in x 0.75in) — entire receipt MUST fit on one label. */
  @page { size: 2in 0.75in; margin: 0; }
  html, body { margin: 0; padding: 0; }
  body {
    font-family: 'JetBrains Mono', ui-monospace, Menlo, monospace;
    color: #000;
    width: 2in; height: 0.75in;
    padding: 0.03in 0.06in;
    box-sizing: border-box;
    overflow: hidden;
    font-size: 5px;
    line-height: 1.05;
  }
  .head { display: flex; justify-content: space-between; align-items: baseline; gap: 4px; }
  .store { font-size: 6px; font-weight: 800; letter-spacing: 0.03em; text-transform: uppercase; }
  .inv { font-size: 5px; font-weight: 700; white-space: nowrap; }
  .meta { font-size: 4.5px; display: flex; justify-content: space-between; gap: 4px; }
  .meta span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  table { width: 100%; border-collapse: collapse; margin-top: 1px; }
  td { font-size: 5px; line-height: 1.05; padding: 0; vertical-align: top; }
  .qty { width: 8px; }
  .amt { text-align: right; white-space: nowrap; width: 28px; }
  .name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding: 0 3px; }
  .totals { margin-top: 1px; display: flex; justify-content: flex-end; gap: 6px; font-size: 5px; }
  .grand { font-size: 7px; font-weight: 900; }
  .hr { border-top: 1px solid #000; margin: 1px 0; }
</style>
</head><body>
  <div class="head">
    <span class="store">${escapeHtml(store.name)}</span>
    <span class="inv">${escapeHtml(r.invoiceNumber)}</span>
  </div>
  <div class="meta">
    <span>${escapeHtml(dateStr)}</span>
    ${cust ? `<span>${escapeHtml(cust)}</span>` : ""}
  </div>
  <div class="hr"></div>
  <table><tbody>${itemRows}</tbody></table>
  <div class="hr"></div>
  <div class="totals">
    <span>Sub $${r.subtotal.toFixed(2)}</span>
    <span>Tax $${r.tax.toFixed(2)}</span>
    <span class="grand">$${r.total.toFixed(2)}</span>
  </div>
<script>window.addEventListener('load', function(){ setTimeout(function(){ window.print(); }, 150); });</script>
</body></html>`);
  w.document.close();
};
